import React, { useEffect } from 'react'

import { useConnect } from 'redux-bundler-hook'

import { Box, CircularProgress } from '@mui/material'

import createLogger from '../Lib/Logging'

const displayName = 'SpinnerRoute'
const logger = createLogger(displayName)

const SpinnerComponent = () => {
  const { doAuthReset, doUpdateUrl } = useConnect('doAuthReset', 'doUpdateUrl')

  useEffect(() => {
    logger.debug('mounted')
    const timeoutId = setTimeout(() => {
      logger.warn('SpinnerRoute timeout, redirecting to /login')
      doAuthReset()
      doUpdateUrl('/login')
    }, 30_000)
    return () => {
      clearTimeout(timeoutId)
      logger.debug('unmounted')
    }
  }, [doAuthReset, doUpdateUrl])

  return (
    <Box
      className="center-all"
      overflow="hidden"
      minHeight="100vh"
    >
      <CircularProgress color="primary" data-testid="aroya-spinner-route" size={100} />
    </Box>
  )
}
SpinnerComponent.displayName = displayName

export default SpinnerComponent
